import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "react-modal";
import { Box, Button, ClickAwayListener, createTheme, Fade, Paper, Popper } from "@mui/material";
import { ThemeProvider } from "@emotion/react";

const theme = createTheme({
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          padding: "10px",
        },
      },
    },
  },
});

interface MessageModalInterface extends Props {
  message: string;
  onClose: () => void;
  prePopulate?: boolean;
  managePrepopulate?: any;
  anchor: any;
}

const DataCaptureMessageModal: React.FC<MessageModalInterface> = ({
  isOpen,
  message,
  onClose,
  prePopulate,
  managePrepopulate,
  anchor,
  ...props
}) => {
  const [t] = useTranslation();
  const handleClickInsidePopper = (event: MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <Popper
          className="comfirmationPopperStyle"
          open={isOpen}
          transition
          anchorEl={anchor}
        >
          {({ TransitionProps }) => (
            <ClickAwayListener
              onClickAway={() => {
                onClose();
              }}
            >
              <Fade {...TransitionProps} timeout={350}>
                <Paper
                  sx={{ boxShadow: "1px 2px 2px #ccc" }}
                  onClick={() => handleClickInsidePopper}
                >
                  <Box
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{ fontSize: "14px", textAlign: "center" }}>
                      {message}
                    </Box>
                    <Box sx={{ mt: "20px", textAlign: "center" }}>
                      <Button
                        className="smallButton"
                        sx={{ mr: "10px" }}
                        onClick={onClose}
                        variant="contained"
                        size="small"
                      >
                        {t("BACK")}
                      </Button>
                      {prePopulate && (
                        <Button
                          className="smallButton"
                          sx={{ mr: "10px" }}
                          onClick={managePrepopulate}
                          variant="contained"
                          size="small"
                        >
                          {t("PRE_POPULATE_ANYWAYS")}
                        </Button>
                      )}
                    </Box>
                  </Box>
                </Paper>
              </Fade>
            </ClickAwayListener>
          )}
        </Popper>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default DataCaptureMessageModal;
